var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnofficialVisitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.309,
    height: 32.687,
    viewBox: "0 0 24.309 32.687",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#666;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.2,0h-.051A12.168,12.168,0,0,0,0,12.155c0,3.674,1.878,6.54,3.971,9.394l8.166,11.138s7.719-10.479,8.2-11.138c2.093-2.854,3.971-5.72,3.971-9.394A12.168,12.168,0,0,0,12.2,0Zm6.59,20.416c-.483.659-5.554,7.6-6.633,9.065L5.515,20.417c-1.97-2.686-3.6-5.162-3.6-8.262A10.251,10.251,0,0,1,12.106,1.915h.049a10.251,10.251,0,0,1,10.24,10.24c0,3.1-1.63,5.575-3.6,8.262Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M87.5,80.48A7.017,7.017,0,1,0,94.518,87.5,7.024,7.024,0,0,0,87.5,80.48Zm0,12.118a5.1,5.1,0,1,1,5.1-5.1A5.107,5.107,0,0,1,87.5,92.6Zm0,0",
    transform: "translate(-75.347 -75.343)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnofficialVisitIcon);
export default __webpack_public_path__ + "static/media/unofficial-visit-icon.baa05ca132c8fe7f35ad3df6770ac5b2.svg";
export { ForwardRef as ReactComponent };